import { HttpClient } from "@angular/common/http";
import { Inject, inject, Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { MessageErrorResolver } from "src/app/core/utilities/message-error-resolver";
import { LoadingService } from "../loading.service";
import { TournamentSportTemplatePostForm } from "@models/competition/sport-parameterization/forms/tournament-sport-template-post-form";
import { ITournamentSportTemplateDto } from "@models/competition/sport-parameterization/dtos/tournament-sport-template-dto";
import { catchError, EMPTY, map, Observable } from "rxjs";
import { ResponseDto, ResponseWithErrorDto } from "@models/exceptions/response-dto";
import { ScoreTemplateWoPostForm } from "@models/competition/sport-parameterization/forms/wo-scoreboard-template-post-form";
import { IScoreTemplateWoDto } from "@models/competition/sport-parameterization/dtos/wo-scoreboard-template-dto";
import { ITieBreakCriteriaDto } from "@models/competition/sport-parameterization/dtos/tie-break-criteria-dto";
import { IPage } from "@models/pagination/page";
import { LinkModalityCriteriaForm } from "@models/competition/sport-parameterization/forms/link-modalitycriteria-form";
import { SportParametrizationFilter } from "@models/competition/sport-parameterization/filters/sport-parametrization-filter";
import { toParams } from "src/app/core/utilities/utility-functions";
import { IPageable } from "@models/pagination/pageable";

@Injectable({
    providedIn: 'root'
})
export class SportParameterizationService {

    private url: string = environment.apiUrl + '/v1/esportes-torneios-templates';
    private scoreUrl: string = environment.apiUrl + '/v1/placares-template-wo';
    private tieBreakUrl: string = environment.apiUrl + '/v1/modalidade-criterios';
    private tieBreakcriteriaUrl: string = environment.apiUrl + '/v1/criterios-desempate';


    private httpClient = inject(HttpClient);
    private messageErrorResolver = inject(MessageErrorResolver)

    public editOrCreateSportTemplate(form: TournamentSportTemplatePostForm): Observable<ITournamentSportTemplateDto> {
        return this.httpClient.post<ResponseDto<ITournamentSportTemplateDto>>(`${this.url}`, form)
            .pipe(
                map(response => response.response),
                catchError((error: ResponseWithErrorDto) => {
                    this.messageErrorResolver.resolveMessage(error);
                    return EMPTY;
                })
            );
    }


    public saveOrUpdateWoScoreboards(forms: ScoreTemplateWoPostForm[]): Observable<IScoreTemplateWoDto[]> {
        return this.httpClient.post<ResponseDto<IScoreTemplateWoDto[]>>(`${this.scoreUrl}`, forms).pipe(
            map(response => response.response),
            catchError((error: ResponseWithErrorDto) => {
                this.messageErrorResolver.resolveMessage(error);
                return EMPTY;
            })
        );
    }

    public getSportTemplateById(ettNrId: number): Observable<ITournamentSportTemplateDto> {
        return this.httpClient
            .get<ResponseDto<ITournamentSportTemplateDto>>(`${this.url}/${ettNrId}`)
            .pipe(
                map(res => res.response),
                catchError((error: ResponseWithErrorDto) => {
                    this.messageErrorResolver.resolveMessage(error);
                    return EMPTY;
                })
            );
    }
    public getSportTemplateByFilter(filter:SportParametrizationFilter,page:IPageable){
        const params = toParams(filter,page);
        return this.httpClient.get<ResponseDto<IPage<ITournamentSportTemplateDto>>>(`${this.url}/buscar-templates`,{params})
    }
    public getWoScoreboardsByTemplateId(ettNrId: number): Observable<IScoreTemplateWoDto[]> {
        return this.httpClient
            .get<ResponseDto<IScoreTemplateWoDto[]>>(`${this.scoreUrl}/por-template/${ettNrId}`)
            .pipe(
                map(res => res.response),
                catchError((error: ResponseWithErrorDto) => {
                    this.messageErrorResolver.resolveMessage(error);
                    return EMPTY;
                })
            );
    }

   public getDefaultSportTemplate(fedNrId: number, espNrId: number): Observable<ITournamentSportTemplateDto> {
    console.log('Chamada no service', fedNrId, espNrId);
    return this.httpClient
        .get<ResponseDto<ITournamentSportTemplateDto>>(`${this.url}/${fedNrId}/template-padrao/${espNrId}`)
        .pipe(
            map(res => res.response)
        );
}

    public listCriteriaByTemplateId(ettNrId: number, page: number = 0, size: number = 10): Observable<IPage<ITieBreakCriteriaDto>> {
        const params = { page, size };
        return this.httpClient
            .get<ResponseDto<IPage<ITieBreakCriteriaDto>>>(`${this.tieBreakUrl}/${ettNrId}`, { params })
            .pipe(
                map(res => res.response),
                catchError((err: ResponseWithErrorDto) => {
                    this.messageErrorResolver.resolveMessage(err);
                    return EMPTY;
                })
            );
    }

    public linkCriteriaToModality(
        ettNrId: number,
        form: LinkModalityCriteriaForm
    ): Observable<ITieBreakCriteriaDto[]> {
        return this.httpClient
            .post<ResponseDto<ITieBreakCriteriaDto[]>>(`${this.tieBreakUrl}/${ettNrId}`, form)
            .pipe(
                map(res => res.response),
                catchError((err: ResponseWithErrorDto) => {
                    this.messageErrorResolver.resolveMessage(err);
                    return EMPTY;
                })
            );
    }

    public listAllTieBreakCriteria(page: number = 0, size: number = 100): Observable<IPage<ITieBreakCriteriaDto>> {
        const params = { page, size };

        return this.httpClient
            .get<ResponseDto<IPage<ITieBreakCriteriaDto>>>(`${this.tieBreakcriteriaUrl}`, { params })
            .pipe(
                map(res => res.response),
                catchError((err: ResponseWithErrorDto) => {
                    this.messageErrorResolver.resolveMessage(err);
                    return EMPTY;
                })
            );
    }

    public deleteWoScoreboardsByIds(pwtNrIds: number[]): Observable<void> {
        const params = { pwtNrIds: pwtNrIds as any };

        return this.httpClient
            .delete<ResponseDto<void>>(`${this.scoreUrl}`, { params })
            .pipe(
                map(() => void 0),
                catchError((err: ResponseWithErrorDto) => {
                    this.messageErrorResolver.resolveMessage(err);
                    return EMPTY;
                })
            );
    }





}